// 万能请求封装
const axios = require('axios');
// 设置跨域请求头
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
// 定义post请求方法
const axiosPost = function(url, params) {
	return new Promise((resolve, reject) => {
		axios
			.post(url, params)
			.then(res => {
				resolve(res);
			})
			.catch(err => {
				reject(err);
			});
	});
};
// 定义get请求方法
const axiosGet = function(url, params) {
	return new Promise((resolve, reject) => {
		axios
			.get(url, {
				params,
			})
			.then(res => {
				resolve(res);
			})
			.catch(err => {
				reject(err);
			});
	});
};


export async function getCity(address = "110101") {
	// console.log(address)
	const params = {
		key: '5a7fb479e0cb23abf8592b9d1f165692', // 你的key  1
		city: address, // 你的地址信息 2
		extensions: "base"
	};
	let res = await axiosGet("https://restapi.amap.com/v3/weather/weatherInfo", params);
	// let res = await axiosPost(url, params);  post同理
	// console.log('打印res：', res.data)
	return res.data
}

export async function getweathers(address = "长沙市") {
	// console.log(address)
	const params = {
		key: 'Sg4yZX-zdgnVgwQM6', // 你的key  1
		location: address, // 你的地址信息 2
		language: "zh-Hans"
	};
	//未来3天  https://api.seniverse.com/v3/weather/daily.json?key=【你的_api_key】&location=beijing&language=zh-Hans&unit=c&start=-1&days=5
	let res = await axiosGet("https://api.seniverse.com/v3/weather/now.json", params);
	
	return res.data
}

// 执行方法